export const TECH_EMAIL = "developers@graficawebdesign.com";
const PRIO = { high: "Alto", medium: "Medio", low: "Basso" };

const fmtDate = (iso) => new Date(iso || Date.now()).toLocaleString("it-CH", { dateStyle: "short", timeStyle: "short" });

const summary = (a) => ({
  url: a.url, scores: a.scores, word_count: a.word_count, size_kb: a.size_kb, fetched_ms: a.fetched_ms,
  meta: { title: a.meta?.title, description: a.meta?.description, canonical: a.meta?.canonical, viewport: !!a.meta?.viewport },
  headings: a.headings && Object.fromEntries(Object.entries(a.headings).map(([k, v]) => [k, Array.isArray(v) ? v.length : v])),
  images: a.images && { total: a.images.total, missing_alt: a.images.missing_alt },
  links: a.links && { internal: a.links.internal, external: a.links.external },
  analytics: a.analytics,
});

const open = (subject, body) => {
  window.location.href = `mailto:${TECH_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const mailTechSupport = (data, focus) => {
  const { analysis: a, suggestions = [] } = data;
  const body = [
    "Richiesta supporto tecnico — Analisi sito",
    `URL: ${a.url}`,
    `Data analisi: ${fmtDate(data.created_at)}`,
    `Punteggio complessivo: ${a.scores?.overall}/100`,
    `Priorità: ${PRIO[focus.impact] || focus.impact}`,
    `Problema segnalato: ${focus.title}`,
    "",
    "[Messaggi AI]",
    ...suggestions.map((s) => `- ${s.title} (${PRIO[s.impact] || s.impact})\n  ${s.description}`),
    "",
    "[Report completo]",
    JSON.stringify(summary(a)),
  ].join("\n");
  open("notizie sul mio errore", body);
};

export const mailPromo = (data, pack) => {
  const a = data.analysis;
  open("Richiedo di avere info sulla promozione 2 euro al giorno", [
    "Richiesta info — Promozione lancio 2 € al giorno",
    `URL analizzato: ${a.url}`,
    `Data analisi: ${fmtDate(data.created_at)}`,
    `Punteggi: complessivo ${a.scores?.overall}/100 · SEO ${a.scores?.seo} · velocità ${a.scores?.speed} · analytics ${a.scores?.analytics}`,
    `Pacchetto scelto: ${pack === "restyling" ? "Restyling del sito analizzato" : "Nuovo sito WEB/APP professionale"}`,
    "",
    "Nome e telefono:",
  ].join("\n"));
};
